module.exports = __webpack_public_path__ + "static/media/sensores.952d815b.png";